import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import { connect } from 'react-redux';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SettingsPanel from "./settingsPanel";
import { appConstants } from '../../_constants';
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { alertActions } from "../../_actions/alert.actions";
import { commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
// core components
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import Pending from "@material-ui/icons/DeveloperMode";
import Airplane from "@material-ui/icons/AirplanemodeActive";
import SettingsTable from "./settingsTable";
import ThresholdsTable from "./allThresholdsTable";
import CircularProgress from "../../utils/CircularProgress";
import {
    Grid,
    TextField,
    InputLabel,
    FormControl, Select, Input, MenuItem
} from "@material-ui/core";
// import AutocompleteSelect from "../../utils/AutocompleteSelect";
// import classNames from "classnames";

const status = [
    { name: "All Status", value: "-1" },
    { name: "Pending", value: 2 },
    { name: "Approved", value: 1 },
    { name: "Declined", value: 0 }
];

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    negativeColor: {
        color: "red"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    wide: {
        width: "100%",
        minWidth: "300px"
    },

    input: {
        marginTop: "0 !important"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    },
    positiveColor: {
        color: "green"
    }
});

class Settings extends React.Component {
    constructor(props) {
        super(props)
        // this.commentElement = this.commentElement.bind(this);
        this.state = {
            page: 0,
            PageCount: 10,
            PageCount2: 10,
            currentPage: 1,
            currentPage2: 1,
            currentPageSettings: 1,
            from: 0,
            TotalCount: 0,
            TotalCountSettings: 0,
            isOpen: false,
            rowsPerPage: 10,
            airlineId: "",
            searchError: "",
            airlinesData: [],
            pendingData: [],
            pendingOldToken: "",
            pendingNewToken: "",
            airlineOldToken: "",
            airlineNewToken: "",
            selectValue: " ",
            open: false,
            openApprove: false,
            airline: "-1",
            users: [],
            airlineName: "",
            AirlineWalletThresholdPendingId: "",
            createdBy: "",
            editErrorComponent: false,
            errorMessage: "",
            errorComponent: false,
            airlinesThreshold: [],
            allThreshold: [],
            error: false,
            formError: '',
            tabIndex: 0,
            pageRequesting: true,
            reason: "",
            comment: "",
            ApprovedBy: "",
            Status: "",
            openComment: false,
            airlineWalletId: "",
            currentPsc: "",
            editedAirlineId: "",
            statusFilter: "-1",
            airportCode: "-1",
            airportCode2: "",
            airports: [],
            defaultAirportCode: "-1"
        };
    }

    componentDidMount() {
        let { airlines, users, dispatch, airports, user } = this.props;

        if (airlines) {
            this.setState({ airlinesData: airlines })
        }
        else {
            dispatch(commonActions.getAllAirlines());
        }
        if (users) {
            this.setState({ users: users.ResultList })
        }
        else {
            dispatch(commonActions.getAllUsers());
        }
        if (airports) {
            this.setState({ airports })
        } else {
            dispatch(commonActions.getAllAirports());
        }
        if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ defaultAirportCode: userLocation, airportCode: userLocation, airportCode2: userLocation }, () => {
                this.getAllThreshold();
                this.getAirlinesThreshold();
            });
        } else if (user.Location) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ defaultAirportCode: userLocation, airportCode: userLocation, airportCode2: userLocation }, () => {
                this.getAllThreshold();
                this.getAirlinesThreshold();
            })
        } else {
            this.getAirlinesThreshold();
            this.getAllThreshold();
        }
        this.getCurrentPsc();

    };


    componentWillReceiveProps = function (nextProps) {
        const { airlines, users, airports, } = nextProps;
        if (airlines) {
            let modifiedAirlines = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirlines.unshift(allAirlines);
            this.setState({ airlinesData: modifiedAirlines });
        }
        if (users) {
            this.setState({ users: users.ResultList })
        }
        if (airports) {
            let modifiedAirports = [...airports];
            modifiedAirports.unshift({ Name: "All Airports", airportLocation: "-1" });
            this.setState({ airports: modifiedAirports })
        }

    };

    //Get currrent Psc
    getCurrentPsc = () => {
        commonService.getCurrentPsc()
            .then(getPsc => {
                this.setState({ currentPsc: getPsc.response.PscCharge })
            })
            .catch(err => err.response)
    }

    getAirlinesThreshold = (pageNumber = 1) => {
        const { dispatch } = this.props;
        let { airportCode, PageCount } = this.state;
        let fromIndex;
        if (pageNumber === undefined) {
            fromIndex = 1;
            pageNumber = 1;
        } else {
            fromIndex = pageNumber;
        }

        let AirportCode = (airportCode === "-1") ? "" : airportCode.value;


        dispatch(alertActions.startRequest());
        commonService.getAirlinesThreshold(AirportCode, fromIndex, PageCount)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        pageRequesting: false,
                        currentPageSettings: pageNumber,
                        currentPage2: pageNumber,
                        TotalCountSettings: res.response.TotalCount,
                        airlinesThreshold: res.response.AllAirlineWalletThreshold
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.setState({ pageRequesting: false, TotalCountSettings: 0 });
                    dispatch(alertActions.error(res.response));
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response));
            })

    };

    //Displays Airport Name
    filterAirport = (airportCode) => {
        const { airports } = this.state;
        let result = airports.find(item => item.Code === airportCode);
        let name = result ? result.Name : "Unknown Airport";
        return name
    }

    getAllThreshold = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const { PageCount2, airline, airportCode, statusFilter } = this.state;

        let fromIndex;
        if (pageNumber === undefined) {
            fromIndex = 1;
            pageNumber = 1;
        } else {
            fromIndex = pageNumber;
        }


        let Airline = (airline === "-1") ? "" : airline.value;
        let AirportCode = (airportCode === "-1") ? "" : airportCode.value;
        let Status = (statusFilter === "-1") ? "" : statusFilter.value;

        dispatch(alertActions.startRequest());
        commonService.getAllThreshold(Airline, AirportCode, Status, fromIndex, PageCount2)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (res.response.PendingAirlineWalletThreshold) {
                        this.setState({
                            pageRequesting: false, currentPage: pageNumber, TotalCount: res.response.TotalCount,
                            allThreshold: res.response.PendingAirlineWalletThreshold
                        })
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response));
            })

    };

    filterUsers = (userId) => {
        // return userId;
        const { users } = this.state;
        if (users) {
            let userName = users.find(u => u.Id === userId);
            if (userName) {
                return `${userName.FirstName} ${userName.LastName}`
            } else {
                return 'Unknown User'
            }
        }
    };

    filterAirlines = (airlineId) => {
        // return userId;
        const { airlinesData } = this.state;
        let airlineName = airlinesData.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return 'Unknown Airline'
        }
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false, isOpen: false, openComment: false });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleEdit = (record) => {
        const { user } = this.props;
        const { Id, AirlineName, OldToken, NewToken, AirlineId, AirportCode } = record;
        this.setState({
            open: true,
            AirlineWalletThresholdPendingId: Id,
            airlineName: AirlineName,
            airlineOldToken: OldToken,
            airlineNewToken: NewToken,
            editedAirlineId: AirlineId,
            airportCode2: AirportCode,
        });
        if (user.AppRole === "Admin") {
            this.setState({ airportCode2: AirportCode })
        }
    }
    //for Input and select
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSelect = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }


    handleReactSelectChange = (value, name) => {
        // console.log({value, name})
        this.setState({ [name.name]: value });
        if (value.value === undefined || value.value === "-1" || value.value === "") {
            this.setState({ [name.name]: "-1" })
        }
    };

    //Edit Threshold
    handleEditToken = () => {
        const { AirlineWalletThresholdPendingId, airlineOldToken, airlineNewToken, editedAirlineId, airportCode2 } = this.state;
        const { user, dispatch } = this.props;
        let payload = {
            "AirlineWalletThresholdPendingId": AirlineWalletThresholdPendingId,
            "OldToken": airlineOldToken,
            "NewToken": airlineNewToken,
            "CreatedBy": user.userId,
            "AirlineId": editedAirlineId,
            "AirportCode": airportCode2
        };
        dispatch(alertActions.startRequest());
        commonService.editPendingThreshold(payload)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.getAllThreshold();
                    this.setState({ open: false, editErrorComponent: false, airlineId: "", errorMessage: "", airportCode2: user.AppRole });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ errorMessage: res.response, editErrorComponent: true })
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
                this.setState({ errorMessage: err.response, editErrorComponent: true })
            });

    }


    //Approve Threshold Modal
    handleApproveToken = (status, id) => {
        this.setState({
            airlineWalletId: id,
            status: status,
            openComment: true,
        })
        status === 0 && this.setState({ reason: "Decline" });
        status === 1 && this.setState({ reason: "Approval" });
    }

    //Comment Modal
    openSubmitComment = () => {
        const { user, dispatch } = this.props;
        const { airlineWalletId, status, comment } = this.state;
        let payload = {
            "AirlineWalletThresholdPendingId": airlineWalletId,
            "ApprovedBy": user.userId,
            "Status": status,
            "Comment": comment
        };
        dispatch(alertActions.startRequest());
        commonService.approvePendingThreshold(payload)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(`Token ${res.response} Successfully`))
                    this.getAllThreshold();
                    this.getAirlinesThreshold();
                    this.setState({ openApprove: false, openComment: false, comment: "" })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ errorMessage: res.response })
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });

    };


    //Set Threshold Button
    handleSubmit = () => {
        const { newToken, airlineId, airlinesThreshold, airportCode2, defaultAirportCode } = this.state;
        let Airline = airlinesThreshold.find(airline => airline.AirlineId === airlineId.value);
        let oldToken = (Airline) ? Airline.Token : '';
        const { user, dispatch } = this.props;
        let payload = {
            "AirlineId": airlineId.value,
            "OldToken": oldToken ? oldToken : 0,
            "NewToken": newToken,
            "AirportCode": airportCode2.value,
            "CreatedBy": user.userId
        }
        dispatch(alertActions.startRequest());
        commonService.setThreshold(payload)
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ formError: res.response, error: true, airlineId: "", airportCode2: defaultAirportCode })
                }
                else if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response))
                    this.setState({ error: false })
                    this.getAllThreshold();
                    this.getAirlinesThreshold();
                    this.setState({ open: false, isOpen: false, airlineId: "", airportCode2: defaultAirportCode })
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            })
    }

    //Add Threshold modal
    handleAdd = () => {
        this.setState({ isOpen: true })
    }

    // getkey = (key) => {
    //     this.setState({tabIndex:key})
    // }
    
    selectedTab = (key) => {
        // this.setState({currentTab: key})
    };

    render() {
        const { classes, user, fullScreen, requesting } = this.props;
        const {
            airports,
            airportCode,
            airportCode2,
            currentPsc,
            isOpen,
            open,
            setUrl,
            oldToken,
            newToken,
            searchError,
            airlineNewToken,
            airlineOldToken,
            airlineId,
            airline,
            errorMessage,
            editErrorComponent,
            airlinesData,
            airlinesThreshold,
            allThreshold,
            TotalCount,
            TotalCountSettings,
            PageCount,
            currentPage,
            error,
            formError,
            pageRequesting,
            comment,
            reason,
            editedAirlineId,
        } = this.state;

        if (pageRequesting)
            return (
                <CircularProgress />
            );

        return (
            <GridContainer>

                <SettingsPanel
                    open={open}
                    error={error}
                    formError={formError}
                    isOpen={isOpen}
                    user={user}
                    handleClose={this.handleClose}
                    handleAdd={this.handleAdd}
                    handleSubmit={this.handleSubmit}
                    setUrl={setUrl}
                    oldToken={oldToken}
                    newToken={newToken}
                    airlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? airlineId : airlineId.value)}
                    airline={airline}
                    airlinesData={airlinesData}
                    handleChange={(event) => this.handleChange(event)}
                    currentPsc={currentPsc}
                    airports={airports}
                    airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
                    handleSelect={this.handleSelect}
                    disabled={requesting}
                    reactSelectChange={this.handleReactSelectChange}
                />

                <Tabs
                    // getKey = {this.getkey}
                    headerColor="success"
                    tabs={[
                        {
                            tabName: "Token Re-order Level",
                            tabIcon: Airplane,
                            clickEvent: (key) => this.selectedTab(key),
                            tabContent: (
                                <GridItem xs={12} sm={12} md={12}>
                                    <SettingsTable
                                        classes={this.props.classes}
                                        totalCounts={TotalCountSettings}
                                        handleEdit={this.handleEdit}
                                        filterUsers={this.filterUsers}
                                        filterAirlines={this.filterAirlines}
                                        fetchRecords={this.getAirlinesThreshold}
                                        currentPage={this.state.currentPageSettings}
                                        pageSize={this.state.PageCount}
                                        user={user}
                                        filterAirport={this.filterAirport}
                                        records={airlinesThreshold}
                                    />
                                </GridItem>
                            )
                        },
                        {
                            tabName: "Pending Re-order Level Approval",
                            tabIcon: Pending,
                            clickEvent: (key) => this.selectedTab(key),
                            tabContent: (
                                <GridItem xs={12} sm={12} md={12}>
                                    <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                                        <ThresholdsTable
                                            airline={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? airline : airline.value)}
                                            airports={airports}
                                            airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
                                            status={status}
                                            statusFilter={this.state.statusFilter.value}
                                            handleSelect={this.handleSelect}
                                            reactSelectChange={this.handleReactSelectChange}
                                            airlinesData={airlinesData}
                                            handleSearch={this.getAllThreshold}
                                            classes={this.props.classes}
                                            totalCounts={TotalCount}
                                            handleEdit={this.handleEdit}
                                            filterUsers={this.filterUsers}
                                            fetchRecords={this.getAllThreshold}
                                            currentPage={currentPage}
                                            pageSize={PageCount}
                                            searchError={searchError}
                                            user={user}
                                            records={allThreshold}
                                            handleApproveToken={this.handleApproveToken}
                                            filterAirlines={this.filterAirlines}
                                            filterAirport={this.filterAirport}
                                        />
                                    </div>
                                </GridItem>
                            )
                        }
                    ]}
                />
                {/*// Edit Modal*/}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#66bb6a" }}>
                        <span style={{ color: "white", textTransform: "uppercase" }}> {this.state.editedAirlineId ? this.filterAirlines(this.state.editedAirlineId) : ""}</span>
                    </DialogTitle>
                    <DialogContent>
                        <GridContainer>
                            <GridItem md={12} sm={12}>
                                <FormControl className={classes.formControl}>
                                        <InputLabel shrink htmlFor="airlineId">
                                            Airline
                                        </InputLabel>
                                        <Select
                                            value={editedAirlineId}
                                            onChange={(e)  => this.handleChange(e)}
                                            name="editedAirlineId"
                                            input={
                                                <Input name="airline" id="airline-label-placeholder" />
                                            }
                                        >
                                            <MenuItem value="Placeholder">Select Airline</MenuItem>
                                            {airlinesData.map((option, i) => (
                                                <MenuItem
                                                    key={i}
                                                    value={option.AirlineId}
                                                    className={classes.select}
                                                >
                                                    {option.Airline}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    {/*<InputLabel shrink htmlFor="age-simple">Select Airline</InputLabel>*/}
                                    {/*<AutocompleteSelect*/}
                                        {/*options={airlinesData.map(option => ({ value: option.AirlineId, label: option.Airline }))}*/}
                                        {/*selectedOption={airlineName}*/}
                                        {/*handleSelectChange={(e, name) => this.handleReactSelectChange(e, name)}*/}
                                        {/*// selectLabel={"Airlines"}*/}
                                        {/*value={airlineName}*/}
                                        {/*name={"airlineId"}*/}

                                    {/*/>*/}
                                    {/*<Select*/}
                                    {/*value={airlineId}*/}
                                    {/*onChange={this.handleChange}*/}
                                    {/*inputProps={{*/}
                                    {/*name: 'airlineId',*/}
                                    {/*id: 'airline',*/}
                                    {/*}}*/}
                                    {/*>*/}
                                    {/*<MenuItem value="Placeholder">Select Airline</MenuItem>*/}
                                    {/*{airlinesData.map((option, i) => (*/}
                                    {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.AirlineId}*/}
                                    {/*className={classes.select}*/}
                                    {/*>*/}
                                    {/*{option.Airline}*/}
                                    {/*</MenuItem>*/}
                                    {/*))}*/}
                                    {/*</Select>*/}
                                </FormControl>
                            </GridItem>
                            <Grid item md={12} sm={12}>
                                <FormControl className={classes.formControl}>
                                    {/*<InputLabel shrink htmlFor="age-simple">Airports</InputLabel>*/}
                                    {/*<AutocompleteSelect*/}
                                        {/*options={airports.map(option => ({ value: option.Code, label: option.Name }))}*/}
                                        {/*selectedOption={(user.AppRole !== "Admin" ? airportCode2 : airportCode2.value)}*/}
                                        {/*handleSelectChange={(e, name) => this.handleReactSelectChange(e, name)}*/}
                                        {/*// selectLabel={"Airlines"}*/}
                                        {/*name={"airportCode2"}*/}
                                        {/*disabled={user.AppRole !== "Admin"}*/}
                                    {/*/>*/}
                                    <Select
                                    disabled= {user.AppRole !== "Admin"}
                                    value={airportCode2}
                                    onChange={(event)=>this.handleSelect(event)}
                                    formcontrolprops={{
                                    fullWidth: true
                                    }}
                                    inputProps={{
                                    name: 'airportCode2',
                                    id: 'airportCode2',
                                    }}
                                    >
                                    <MenuItem value="Placeholder">Select Airport</MenuItem>
                                    {airports.map((option, i) => (
                                    <MenuItem
                                    key={i}
                                    value={option.Code}
                                    className={classes.select}
                                    >
                                    {option.Name}
                                    </MenuItem>
                                    ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="Current Token"
                                    id="airlineOldToken"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={
                                        {
                                            disabled: true,
                                            value: airlineOldToken,
                                            name: "airlineNewToken",
                                            type: "number",
                                            onChange: this.handleChange,
                                        }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="New Token"
                                    id="airlineNewToken"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={
                                        {
                                            required: true,
                                            value: airlineNewToken,
                                            name: "airlineNewToken",
                                            type: "number",
                                            onChange: this.handleChange,
                                        }}
                                />
                                {editErrorComponent && <div style={{ color: 'red', fontSize: "13px" }}>{errorMessage}</div>}
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="danger">
                            Cancel
            </Button>
                        <Button onClick={this.handleEditToken} color="primary" autoFocus>
                            Submit
            </Button>
                    </DialogActions>
                </Dialog>

                {/*//Comment Modal*/}
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.openComment}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#66bb6a" }}>
                        <span style={{ color: "white", textTransform: "uppercase" }}>Reason for {reason}</span>
                    </DialogTitle>
                    <DialogContent>
                        <GridContainer>
                            <Grid item md={12} sm={12}>
                                <TextField
                                    className={classes.wide}
                                    // disabled = {disabled}
                                    // disabled={disabled}
                                    multiline
                                    rowsMax="10"
                                    id="email"
                                    label="Reason"
                                    name="comment"
                                    value={comment}
                                    onChange={this.handleChange}
                                    margin="normal"
                                    variant="outlined"
                                />
                                <div className={classes.nb}>*State your reason</div>
                                {/*<span>*/}
                                {/*<Button onClick={this.handleActiveInput} color="success" autoFocus>*/}
                                {/*Edit*/}
                                {/*</Button>*/}
                                {/*</span>*/}
                            </Grid>
                        </GridContainer>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.openSubmitComment} color="primary" autoFocus>
                            Submit
                  </Button>
                    </DialogActions>
                </Dialog>


            </GridContainer>
        );
    }
}

SettingsTable.defaultProps = {
    tableHeaderColor: "gray"
};

SettingsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "warning",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    tableHead: PropTypes.arrayOf(PropTypes.string),
    tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

const mapStateToProps = state => {
    const { modal, alert, airlines, airports, progress, user, users, requesting } = state;
    return {
        users,
        modal,
        alert,
        airlines,
        airports,
        progress,
        user,
        requesting
    };
};

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(Settings));



// WEBPACK FOOTER //
// ./src/views/Settings/Index.jsx